import { AddIcon } from '@chakra-ui/icons';
import { HStack } from '@chakra-ui/react';
import { useCallback, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import useGetEngines from './queries/useGetEngines';

import { Button, Text } from '@/components/v4';
import AGGridMain from 'components/tables/AGGrid/AGGridMain';
import useColumnState from '../../../hooks/useColumnState';

import { getEngineTableColumns, getEngineRowStyle } from './engineTableConfig';

export default function Engines() {
    const gridRef = useRef();
    const navigate = useNavigate();

    const { darkMode } = useSelector((state) => state.settings);

    const [tableData, setTableData] = useState({
        columns: [],
        data: [],
    });

    const handleViewEngine = useCallback(
        (engineData) => {
            navigate(`/engines/view/${engineData.id}`);
        },
        [navigate],
    );

    const handleAddEngine = () => {
        navigate('/engines/add');
    };

    const baseColumns = useMemo(
        () =>
            getEngineTableColumns({
                darkMode,
                onViewEngine: handleViewEngine,
            }),
        [darkMode, handleViewEngine],
    );

    const { columns, onColumnVisible } = useColumnState(baseColumns);

    const getRowStyle = useMemo(() => getEngineRowStyle(darkMode), [darkMode]);

    const tableDataWithColumns = useMemo(
        () => ({
            columns,
            data: tableData.data,
        }),
        [columns, tableData.data],
    );

    const { refetch, isRefetching, isFetching } = useGetEngines(
        setTableData,
        gridRef,
        baseColumns,
    );

    const isFetchingData = isRefetching || isFetching;

    const titleName = 'Engines';

    return (
        <>
            <HStack justifyContent="space-between" marginBottom={5}>
                <Text sx={{ fontSize: '20', fontWeight: '500' }}>Engines</Text>
            </HStack>

            <AGGridMain
                gridRef={gridRef}
                tableData={tableDataWithColumns}
                isLoading={isFetchingData}
                titleName={titleName}
                refetch={refetch}
                onColumnVisible={onColumnVisible}
                getRowStyle={getRowStyle}
                extraComponents={
                    <HStack pl={5} spacing={2}>
                        <Button
                            leftIcon={<AddIcon />}
                            onClick={handleAddEngine}
                            size="sm"
                            padding="6px 12px">
                            Add Engine
                        </Button>
                    </HStack>
                }
            />
        </>
    );
}
